import { render, staticRenderFns } from "./IntentPage.vue?vue&type=template&id=deac2790"
import script from "./IntentPage.vue?vue&type=script&lang=js"
export * from "./IntentPage.vue?vue&type=script&lang=js"
import style0 from "./IntentPage.vue?vue&type=style&index=0&id=deac2790&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports